export default __webpack_public_path__ + "static/media/4153079N8739049W-sm.83c50e22.jpg";